"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComponentEntry = (function () {
    function ComponentEntry(component, conditions) {
        this.component = component;
        this.conditions = conditions;
    }
    return ComponentEntry;
}());
exports.default = ComponentEntry;
//# sourceMappingURL=ComponentEntry.js.map